import { CButton, CModal, CModalBody, CRow, CCol } from '@coreui/react'
import React, { useContext, useState } from 'react'
import './CommonButtonComp.scss'
import CloseIcon from '../../../assets/images/IntegrationMontioring/dark-close-icon.svg'
import { useNavigate } from 'react-router-dom'
import WhiteCircleIcon from '../../../assets/images/IntegrationMontioring/white-circle.svg'
import CloseIconBlack from '../../../assets/images/IntegrationMontioring/light-close-icon.svg'
import IM_Context from '../../Contexts/IM_Context/Im_Context'

const CommonButtonComp = (props) => {
  const [visible, setVisible] = useState(false)
  const { isDarkTheme, setClickChanged, setShowClickedTile, setShowSpeedometer } =
    useContext(IM_Context)
  const navigate = useNavigate()
  const mockModalData = [
    {
      platForm: 'HAPI (Global, China & GCP) & Postman Enterprise',
      group: 'API Operations',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    {
      platForm: 'HMesh & BIN',
      group: 'Event Operations',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    {
      platForm: 'Integration Message Tracker & Integration Monitoring Dashboard',
      group: 'API CoE',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
  ]

  const GoToBam = (props) => {
    if (!props.showModal && props?.toLowerCase() === 'integration message tracker') {
      navigate('/imt')
    } else {
      window.open(
        'https://hm.service-now.com/now/nav/ui/classic/params/target/%24pa_dashboard.do%3Fsysparm_dashboard%3D2c91be969322a558b7ca382d6cba107d',
        '_blank',
      )
    }
  }
  const handleClick = (props) => {
    if (props.toLowerCase() === 'report incident') {
      setVisible(true)
    }
  }

  return (
    <div className="cursor-pointer">
      {props.footerCard ? (
        <div className={`${isDarkTheme ? 'footer-button-wrap' : 'im-button-wrap-light'}`}>
          <span onClick={() => {}} onKeyDown={() => {}}>
            <div className="footer-content">
              <CButton
                className="footer-button-cnt"
                onClick={() => {
                  setShowClickedTile(props?.ButtonText)
                  setClickChanged(true)
                  setShowSpeedometer(true)
                }}
              >
                {props?.ButtonText}
                <div className={`pulsating-circle-${props.color?.toLowerCase()}-footer`}></div>
              </CButton>
            </div>
          </span>
        </div>
      ) : props?.ButtonText !== 'Report Incident' ? (
        <div className={`${isDarkTheme ? 'im-button-wrap' : 'im-button-wrap-light'}`}>
          <div
            onClick={() => {
              setVisible(!visible)
              GoToBam(props?.ButtonText)
            }}
            onKeyDown={() => {}}
          >
            <CButton className="button-cnt">{props?.ButtonText}</CButton>
          </div>
        </div>
      ) : (
        <div
          className={`${isDarkTheme ? 'im-button-wrap' : 'im-button-wrap-light'} cursor-pointer`}
        >
          <div
            onClick={() => {
              handleClick(props?.ButtonText)
            }}
            onKeyDown={() => {}}
          >
            <CButton className="button-cnt">{props?.ButtonText}</CButton>
          </div>
        </div>
      )}
      <CModal
        backdrop="static"
        visible={visible && props?.showModal}
        className={`${isDarkTheme ? 'production-issue-cnt' : 'production-issue-light'}`}
        size="xl"
        scrollable
      >
        <div className={`${isDarkTheme ? 'modal-container' : 'modal-container-light '}`}>
          <div className="closeIcon-Container">
            <span onClick={() => setVisible(false)} onKeyDown={() => {}} className="close-btn">
              <img src={isDarkTheme ? CloseIcon : CloseIconBlack} alt="Close" />
            </span>
          </div>
          <CModalBody>
            <div className="production-issue-text">
              Production Issue - To report a production issue in any of our platforms, please assign
              the incidents to the below Assignment groups using the Servicenow Link.
            </div>
            <div className="production-issue-link">
              To view Open Incidents with API COE:{' '}
              <span
                className="link-color mx-2 cursor-pointer"
                onClick={() => {
                  window.open(
                    'https://hm.service-now.com/now/nav/ui/classic/params/target/%24pa_dashboard.do%3Fsysparm_dashboard%3D2c91be969322a558b7ca382d6cba107d',
                    'blank',
                  )
                }}
                onKeyDown={{}}
              >
                Ongoing Incidents
              </span>
            </div>
            <CRow className="pi-table-head">
              <CCol md={6}>Platform</CCol>
              <CCol md={5}>Assignment Group</CCol>
            </CRow>
            {mockModalData?.map((modaldata, i) => (
              <CRow className="pi-table-value" key={i}>
                <CCol md={6} className="margin-bottom-40">
                  {modaldata?.platForm}
                </CCol>
                <CCol md={5}>{modaldata?.group}</CCol>
                <div className="border-bottom"></div>
              </CRow>
            ))}
          </CModalBody>
          <div className="d-flex margin-btn-cnt display-position">
            <CButton
              className="service-now-btn"
              onClick={() => window.open('https://hm.service-now.com/', '_blank')}
            >
              Service now{' '}
              <span className="white-circle-icon white-circle m-0">
                <img src={WhiteCircleIcon} alt="white-circle" />
              </span>
            </CButton>
          </div>
        </div>
      </CModal>
    </div>
  )
}

export default CommonButtonComp
